import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { checkAttendanceMarked } from '../../redux/features/AttendanceCheckSlice';
import AttendanceView from '../../views/user/EmployeeServices/Attendance/AttendanceView';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { ATTENDANCE_BUTTON_ID } from '../../utils/constants/GlobalStaticData';

const AttendanceCheck = () => {
  const { isAttenanceMarked, loading } = useSelector((state) => state.attendanceMarked);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const [isRestrictionEnabled, setIsRestrictionEnabled] = useState(false);

  const handlePopUp = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const cred = JSON.parse(localStorage.getItem('cred')) || {};
    const configArray = cred?.profile?.config || [];

    // ✅ NEW: Restriction is ON if ANY config_status is true
    const restriction = configArray.some((c) => c.config_status === true);

    setIsRestrictionEnabled(restriction);

    dispatch(checkAttendanceMarked()).then((res) => {
      if (restriction) {
        // Restriction ON
        if (!res.payload.data.isAttenanceMarked) {
          handlePopUp();

          const updatedCred = {
            ...cred,
            approvalRequestsSeen: false,
          };
          localStorage.setItem('cred', JSON.stringify(updatedCred));
        }
      } else {
        // Restriction OFF → Nothing blocked
        // console.log('Attendance restriction disabled by config.');
      }
    });
  }, []);

  // 🟢 If loading, don't render anything yet
  if (loading) return null;

  // 🟢 If restriction OFF → always allow Outlet
  if (!isRestrictionEnabled) {
    return <Outlet />;
  }

  // 🟡 Restriction ON → allow Outlet only when attendance is marked
  return isAttenanceMarked ? (
    <Outlet />
  ) : (
    <>
      <AttendanceView loginAttendenceView={true} />

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h5" align="center" gutterBottom>
            Attendance Required
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          <Typography variant="body1" align="center" color="textSecondary" gutterBottom>
            Please Mark Your Attendance To proceed And Access The System
          </Typography>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center', padding: '16px' }}>
          <Button
            onClick={handleClose}
            variant="contained"
            color="primary"
            size="small"
            sx={{ width: '150px', borderRadius: '8px' }}
          >
            Check In
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AttendanceCheck;
